export type UpcomingIpoNavTab = {
  label: string;
  value: string;
  redirectLink?: string;
};

export type UpcomingIpoNavTabsContent = {
  defaultTab?: string;
  tabs?: Array<Record<string, UpcomingIpoNavTab>>;
};

const DEFAULT_NAV_TABS: UpcomingIpoNavTab[] = [
  {
    label: "Stocks",
    value: "stock",
    redirectLink: "/investments/stock-and-trading",
  },
  { label: "IPOs", value: "ipo" },
  {
    label: "Share Market News",
    value: "news",
    redirectLink: "/investments/news",
  },
];

export const parseUpcomingIpoNavTabs = (
  navigationTabs?: UpcomingIpoNavTabsContent,
): { activeTab: string; tabs: UpcomingIpoNavTab[] } => {
  if (!navigationTabs?.tabs?.length) {
    return { activeTab: navigationTabs?.defaultTab ?? "ipo", tabs: DEFAULT_NAV_TABS };
  }

  const tabEntries = Object.values(navigationTabs.tabs[0] ?? {});

  if (!tabEntries.length) {
    return { activeTab: navigationTabs.defaultTab ?? "ipo", tabs: DEFAULT_NAV_TABS };
  }

  return {
    activeTab: navigationTabs.defaultTab ?? "ipo",
    tabs: tabEntries.map(({ label, value, redirectLink }) => ({
      label,
      value,
      redirectLink,
    })),
  };
};
